import {
	type JiraUserBoardNavigationData,
	staticJSWUserBoardSidebarNavigationResource,
} from '@atlassian/jira-navigation-apps-resources';
import { useResource } from '@atlassian/jira-router';
import type { UseJiraUserBoardNavigationResourceReturn } from './types';

export const useJiraUserBoardNavigationResource = (): UseJiraUserBoardNavigationResourceReturn =>
	useResource<JiraUserBoardNavigationData | null>(staticJSWUserBoardSidebarNavigationResource);
